import {css} from "@emotion/react";

import {normalize} from "./normalize";
import {IGlobalTheme, scaffolding} from "./scaffolding";

export const globalStyles = (theme: IGlobalTheme) => css`
    ${normalize};
    ${scaffolding(theme)};
`;
